import React, { useState } from "react";
import { UserCircle2, KeyRound, MapPin, Phone, Wifi, Calendar } from "lucide-react";
import { usePortalAuth } from "./PortalAuthContext";
import { portalApi, errMsg } from "./portalApi";

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3 py-2 border-b border-slate-800/70 last:border-0">
    <Icon className="w-4 h-4 text-slate-500 mt-0.5 shrink-0" />
    <div className="min-w-0"><p className="text-[10px] text-slate-500 uppercase tracking-wider">{label}</p><p className="text-sm text-white break-words">{value || "-"}</p></div>
  </div>
);

export const PortalAkunPage = () => {
  const { customer, refresh } = usePortalAuth();
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [msg, setMsg] = useState({ ok: null, text: "" });
  const [loading, setLoading] = useState(false);
  const c = customer || {};

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return setMsg({ ok: false, text: "Konfirmasi kata sandi tidak sama" });
    setLoading(true);
    setMsg({ ok: null, text: "" });
    try {
      const res = await portalApi.post("/change-password", { old_password: form.old_password, new_password: form.new_password });
      setMsg({ ok: true, text: res.data.message });
      setForm({ old_password: "", new_password: "", confirm: "" });
      refresh();
    } catch (err) {
      setMsg({ ok: false, text: errMsg(err) });
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full px-3 py-2.5 bg-slate-950 border border-slate-700 rounded-xl text-sm text-white focus:border-emerald-500 outline-none";

  return (
    <div className="space-y-4" data-testid="portal-akun">
      <h1 className="text-base font-bold text-white flex items-center gap-2"><UserCircle2 className="w-4 h-4 text-cyan-400" /> Akun Saya</h1>

      <div className="p-4 rounded-2xl bg-[#0d1527] border border-slate-800" data-testid="portal-akun-profile">
        <Row icon={UserCircle2} label="Nama" value={c.nama} />
        <Row icon={Wifi} label="Nomor Layanan / Username" value={`${c.no_layanan || "-"} • ${c.username_pppoe || "-"}`} />
        <Row icon={Phone} label="No. HP / Email" value={[c.no_hp, c.email].filter(Boolean).join(" • ")} />
        <Row icon={MapPin} label="Alamat" value={[c.alamat, c.rt && `RT ${c.rt}`, c.rw && `RW ${c.rw}`, c.desa, c.kecamatan].filter(Boolean).join(", ")} />
        <Row icon={Calendar} label="Tanggal Pasang" value={c.tanggal_pasang} />
        <p className="text-[11px] text-slate-500 mt-2">Untuk perubahan data (alamat/no. HP), hubungi CS kami.</p>
      </div>

      <form onSubmit={submit} className="p-4 rounded-2xl bg-[#0d1527] border border-slate-800 space-y-3" data-testid="portal-change-password-form">
        <h2 className="text-sm font-bold text-white flex items-center gap-2"><KeyRound className="w-4 h-4 text-amber-400" /> Ubah Kata Sandi</h2>
        {msg.text && <div className={`p-2.5 rounded-lg text-xs border ${msg.ok ? "bg-emerald-500/10 border-emerald-500/40 text-emerald-300" : "bg-rose-500/10 border-rose-500/40 text-rose-300"}`} data-testid="portal-change-password-msg">{msg.text}</div>}
        <input type="password" placeholder={c.password_default ? "Kata sandi lama (default 123456)" : "Kata sandi lama"} value={form.old_password} onChange={(e) => setForm({ ...form, old_password: e.target.value })} required className={input} data-testid="portal-old-password" />
        <input type="password" placeholder="Kata sandi baru (min. 6 karakter)" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required minLength={6} className={input} data-testid="portal-new-password" />
        <input type="password" placeholder="Ulangi kata sandi baru" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required className={input} data-testid="portal-confirm-password" />
        <button type="submit" disabled={loading} className="w-full py-2.5 rounded-xl bg-gradient-to-r from-amber-500 to-orange-600 text-white font-semibold text-sm disabled:opacity-60" data-testid="portal-change-password-submit">
          {loading ? "Menyimpan..." : "Simpan Kata Sandi"}
        </button>
      </form>
    </div>
  );
};
